import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PaymentForm } from '../../types/payment';
import { chipColors } from '../../lib/contrast';

const getColor = (key: string) => {
    switch (key) {
        case 'PURSE':
            return '#3186a7';
        case 'DATAFONO':
            return '#a341bb';
        case 'DATAFONO_CONNECTED':
            return '#c792d7';
        case 'CASH':
            return '#f35b77';
        case 'TPV':
            return '#d8af54';
        case 'ZITYCARD':
        case 'FREE':
            return '#75bb41';
        case 'BANK':
            return '#4831a7';
        case 'RECEIPT':
            return '#a86359';
        default:
            return '#b02a00';
    }
};

type SttChipPFormProps = {
    pf?: PaymentForm | '';
};

export function SttChipPForm({ pf }: SttChipPFormProps) {
    const { t } = useTranslation();

    const paymentForm: string = pf ?? '';

    return (
        <Chip
            size="small"
            label={t(`PF.${paymentForm || 'LATER'}`)}
            style={{
                ...chipColors(getColor(paymentForm)),
            }}
        />
    );
}
